module.exports = "/_next/static/media/897ed725d74b163e21d5a75429ded99c.svg";